import { useCallback, useEffect } from "react";
import { useDispatch } from "react-redux";
import { appActions } from "../ducks/app";

interface WOVNWindow extends Window {
  WOVN: {
    io: {
      getCurrentLang: () => { code: string };
      getTextTranslation: (text: string, lang: string) => string;
    };
  };
}

declare const window: WOVNWindow;
let currentLang: string = "";
window.addEventListener("wovnApiReady", function (evt) {
  currentLang = window.WOVN.io.getCurrentLang().code;
});

export const useWOVN = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    window.addEventListener("wovnLangChanged", () => {
      const lng = window.WOVN.io.getCurrentLang().code;
      if (currentLang !== lng) {
        dispatch(appActions.closeLanguageSelectModal());
        dispatch(appActions.showLanguageMessageModal());
      }
      currentLang = lng;
    });
  }, []);

  const getCurrentLang = useCallback(() => {
    return window.WOVN.io.getCurrentLang();
  }, []);

  const getTextTranslation = useCallback((text: string) => {
    return window.WOVN.io.getTextTranslation(text, getCurrentLang().code);
  }, []);

  return { getCurrentLang, getTextTranslation };
};
